import type { Optional } from '@festina-life/core'
import type { MarkdownViewerProps } from '@festina-life/ui/markdown'
import { MarkdownViewer as UiMarkdownViewer } from '@festina-life/ui/markdown'

import { useDocumentationSiteLinkTransformer } from '../../hooks/useDocumentationSiteLinkTransformer'

type ConfigMarkdownViewerProps = Omit<
  MarkdownViewerProps,
  'linkTransformer'
> & {
  shouldTransformLinksToDocSite?: Optional<boolean>
}

export const ConfigurationMarkdownViewer = ({
  shouldTransformLinksToDocSite,
  ...props
}: ConfigMarkdownViewerProps) => {
  const documentationTransformer = useDocumentationSiteLinkTransformer()

  return (
    <UiMarkdownViewer
      {...props}
      linkTransformer={
        shouldTransformLinksToDocSite ? documentationTransformer : undefined
      }
    />
  )
}
